"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var closest = require("../helpers/traversal").closest;

var isDisabled = require("../helpers/form-controls").isDisabled;

var HTMLButtonElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLButtonElementImpl, _HTMLElementImpl);

  function HTMLButtonElementImpl() {
    _classCallCheck(this, HTMLButtonElementImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(HTMLButtonElementImpl).apply(this, arguments));
  }

  _createClass(HTMLButtonElementImpl, [{
    key: "_activationBehavior",
    value: function _activationBehavior() {
      var form = this.form;

      if (form) {
        if (this.type === "submit" && !isDisabled(this)) {
          form._dispatchSubmitEvent();
        }
      }
    }
  }, {
    key: "_getValue",
    value: function _getValue() {
      var valueAttr = this.getAttribute("value");
      return valueAttr === null ? "" : valueAttr;
    }
  }, {
    key: "form",
    get: function get() {
      return closest(this, "form");
    }
  }, {
    key: "type",
    get: function get() {
      var typeAttr = (this.getAttribute("type") || "").toLowerCase();

      switch (typeAttr) {
        case "submit":
        case "reset":
        case "button":
        case "menu":
          return typeAttr;

        default:
          return "submit";
      }
    },
    set: function set(v) {
      v = String(v).toLowerCase();

      switch (v) {
        case "submit":
        case "reset":
        case "button":
        case "menu":
          this.setAttribute("type", v);
          break;

        default:
          this.setAttribute("type", "submit");
          break;
      }
    }
  }]);

  return HTMLButtonElementImpl;
}(HTMLElementImpl);

module.exports = {
  implementation: HTMLButtonElementImpl
};